module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels_BW_Web-p-1600-c498cfff8fa07108c2d1f0aac002e94f.jpg";